<script lang="ts">
	import { getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	//Formatters
	import { format } from 'svelte-i18n';
	//Helpers
	import { real_id } from '../../../helpers/interface_helpers';
	import { getErrorOrInfoMessageForMinAndMax } from '../../../helpers/utilities';
	import { onSettingsResponse } from '../../../helpers/device_settings_helpers';
	//Services
	import { postReq } from '../../../services/http';
	//Stores
		//Design system components
	import { Button, Input, Text } from '@Shelly/shelly-design-system';
	//Types
	import type { SettingRequest } from '../../../types/requests/settings/setting';
	import type { Device } from '../../../types/Device';

	$: settingsStore = getDeviceSettings(id);
	export let device: Device, type: string;

	const id = real_id(device.id);
	const settings = $settingsStore.sensors;
	const localUnit = settings.temperature_unit || 'C';

	let min = device?.type == 'SHMOS-02' ? 0 : 0.5;
	let max = type === 'humidity' ? 50 : 5;

	let value = settings[`${type}_threshold`];
	let waitForResponse = false;
	let unit = localUnit;

	const save = async () => {
		waitForResponse = true;

		let res: SettingRequest;
		if (device.type === 'SHDW-2') {
			res = await postReq(
				`/device/${device.category}/settings/set_command`,
				{
					id,
					set: `${type}_threshold`,
					command: value,
				},
				10000,
			);
		} else {
			res = await postReq(`/device/${device.category}/settings/${type}_threshold`, {
				id,
				threshold: value,
			});
		}

		onSettingsResponse(res, device);
		waitForResponse = false;
	};

	$: inputData = getErrorOrInfoMessageForMinAndMax(value, min, max);

	const handleChange = (e) => {
		value = e.target.value;
	};
</script>

<!-- <Alert
	class="mb-s"
	heading={$format('alert_info_heading_temp_thres_report', {
		values: { type: $format(`the_${type}`) },
		default: `Wake up and report status if ${type} changes by threshold.`
	})}
/> -->

<Text styleType="body-small" class="mb-s">
	{type === 'temperature'
		? $format('alert_info_message_temp_thres_trig_sensor_data', {
				values: { unit },
				default: `Temperature change with more than the specified value in °{unit} triggers sensor data report.`,
			})
		: $format('humidity_threshold_description', {
				default:
					'Threshold for triggering a device wake up. Relative Humidity change with more than the specified value triggers the device to report sensor data',
			})}</Text
>

<Input
	size="m"
	class="mb-s"
	icon="fas fa-calculator"
	on:input={(e) => handleChange(e)}
	{value}
	info={inputData.info}
	error={inputData.error}
	type="number"
	step={1}
	id="input-3ugtgvq"
	aria-label={$format('threshold_wrapper_input', {
		default: 'Threshold value',
	})}
/>

<Button size="m" width="full" loading={waitForResponse} disabled={inputData.error} on:click={save}
	>{$format('button_save', { default: 'Save' })}</Button
>
